import React, { useEffect, useState } from "react";
import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";
import TitleSection from "../../../../components/title-section/title-section";
import Card from "../../../../components/card/card";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";

import internationalIcon from '../../../../assets/imgs/services/international/international_icon.svg';
import specializedLogo from "../../../../assets/imgs/services/international/specialized.svg";
import generalLogo from "../../../../assets/imgs/services/international/general.svg";
import expressLogo from "../../../../assets/imgs/services/international/express.svg";
import customizedLogo from "../../../../assets/imgs/services/international/customized.svg";
import specializedCover from "../../../../assets/imgs/services/international/specialized.jpg";
import generalCover from "../../../../assets/imgs/services/international/general.jpg";
import expressCover from "../../../../assets/imgs/services/international/express.jpg";
import customizedCover from "../../../../assets/imgs/services/international/customized.jpg";
import './international-home.css'

function InternationalHome() {
  const [tInternational] = useTranslation("international");
  const [tSMetaData] = useTranslation("metaData");
  const dataInternational = tInternational("data", { returnObjects: true });
  const idInternationals = "d45a04ef-618d-40de-ada3-cbe93ffa9770";
  const [titleInternational, setTitleInternational] = useState("");
  const [dataInternationalDB, setDataInternationalDB] = useState([]);

  const cardsData = [
    {
      id: 1,
      titleLogo: expressLogo,
      coverImg: expressCover,
      text: "Para su embarque, ofrecemos una confianza y seguridad inigualables, especialmente cuando el tiempo es apremiante.",
      link: "#"
    },
    {
      id: 2,
      titleLogo: generalLogo,
      coverImg: generalCover,
      text: "Para su embarque, ofrecemos una confianza y seguridad inigualables, especialmente cuando el tiempo es apremiante.",
      link: "#"
    },
    {
      id: 3,
      titleLogo: specializedLogo,
      coverImg: specializedCover,
      text: "Para su embarque, ofrecemos una confianza y seguridad inigualables, especialmente cuando el tiempo es apremiante.",
      link: "#"
    },
    {
      id: 4,
      titleLogo: customizedLogo,
      coverImg: customizedCover,
      text: "Para su embarque, ofrecemos una confianza y seguridad inigualables, especialmente cuando el tiempo es apremiante.",
      link: "#"
    }
  ];

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[1]
    }`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[1]
    }`
  );

  const getTexts = async () => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    try {
      const resInternational = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idInternationals}`);

      if (currentLng === "es") {
        setTitleInternational(
          resInternational.data.textWeb.text_es.title["titulo de sección"]
        );
        setDataInternationalDB([
          resInternational.data.textWeb.text_es["express"],
          resInternational.data.textWeb.text_es["general"],
          resInternational.data.textWeb.text_es["specialized"],
          resInternational.data.textWeb.text_es["customized"],
        ]);
      } else {
        setTitleInternational(
          resInternational.data.textWeb.text_us.title["titulo de sección"]
        );
        setDataInternationalDB([
          resInternational.data.textWeb.text_us["express"],
          resInternational.data.textWeb.text_us["general"],
          resInternational.data.textWeb.text_us["specialized"],
          resInternational.data.textWeb.text_us["customized"],
        ]);
      }
    } catch (error) {
      setDataInternationalDB([...dataInternational]);
      console.error(error);
    }
  };

  useEffect(() => {
    getTexts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderCards = () => {
    return dataInternationalDB.map((card, index) => (
      <div key={index} className="col-12 col-md-6 col-xl-4">
        <div className="nationalHomeContainer">
          <Card
            description={card?.texto || ""}
            redirect={card?.["texto-botón-linea"] || ""}
            redirectHref={card?.["link-botón-linea"] || ""}
            linkId={"linkInternational" + index || ""}
            image={card?.imagen}
          />
        </div>
      </div>
    ));
  };

  return (
    <>
      <Helmet>
        <title>{tSMetaData("internacionales.title")}</title>
        <meta
          name="description"
          content={tSMetaData("internacionales.description")}
        />
      </Helmet>
      {/* <TitleSection
        title={titleInternational ?? tInternational("title.title-page")}
      /> */}

      {/* <div
        style={{ marginTop: "20px", marginBottom: "40px" }}
        className="container"
      >
        <div className="row">
          {dataInternationalDB.length > 0 && renderCards()}
        </div>
      </div> */}
      {/* <div className="container-fluid bg-blue-light-in">
        <div className="container">
          <div className="row">
            <div className="col international-bar">
              <img src={internationalIcon} alt="Servicios Internacionales" className="international-icon" />
              <span className="uppercase">{tInternational("title.titulo de sección")}</span>
            </div>
          </div>
        </div>
      </div> */}
      <div className="container-fluid padding-international">
        <div className="row">
          {cardsData.map((card) => (
            /* col-lg-3 mantiene tus 4 columnas en pantallas grandes */
            <div className="col-12 col-lg-3 mb-5" key={card.id}>
              <div className="international-card mx-auto">
                
                {/* Imagen de portada */}
                <div className="international-card-img-wrapper">
                  <img src={card.coverImg} alt="Service Cover" className="img-fluid international-cover-img" />
                </div>

                {/* Cuerpo de la tarjeta */}
                <div className="international-card-content">
                  <img src={card.titleLogo} alt="Service Logo" className="international-service-logo mb-3" />
                  
                  <p className="international-service-text">
                    {card.text}
                  </p>
                  
                  <a href={card.link} className="international-service-link">
                    Leer más
                  </a>
                </div>

              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default InternationalHome;
